import { render, staticRenderFns } from "./QuestionCategoryList.vue?vue&type=template&id=07940c46&scoped=true&"
import script from "./QuestionCategoryList.vue?vue&type=script&lang=js&"
export * from "./QuestionCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCategoryList.vue?vue&type=style&index=0&id=07940c46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07940c46",
  null
  
)

export default component.exports